/**
 * @file
 * @desc 灵机app的平台标示
 * @author mabiao
 * @date 2018-03-27
 */
import {commonFn} from './common';
let iosForPlatform = {
	/* 灵机平台 */
	ljruyuan: '19',
	/* 默认灵机app */
	ljms: '13',
	/* 易起问app */
	yqw: '21',
	/* 灵机八字app */
	ljbz: '25',
	/* 星座城 */
	xingzuocheng: '27',
	// 易起问
	ljds: localStorage.getItem('platform') || '26',
	// 知缘配对
	zhiyuanpeidui: '49',
	// 紫薇命盘
	app_ios_1471953507: '5',
	//顺兽紫微
	app_ios_1471953507: '49'
};
let androidForPlatform = {
	/* 灵机平台 */
	ljruyuan: '18',
	/* 默认灵机app */
	ljms: '12',
	/* 易起问app */
	yqw: '20',
	/* 风水楼盘app */
	fslp: '3',
	/* 星座城 */
	xingzuocheng: '28',
	/* 八字排盘 */
	bazipaipan: '31',
	// 紫微斗数
	zwds: '45',
	// 看手相
	ksx: '46',
	// 起码解名
	qmjm: '6',
	// 易起问
	ljds: localStorage.getItem('platform') || '26',
	// 知缘配对
	zhiyuanpeidui: '50',
	laohuangli: '202'
};
let platform = 12;

let isIos = window.mmc.client.isIOS();

let appPlatform = isIos ? iosForPlatform : androidForPlatform;

if (!commonFn.isH5()) {
	try {
		const app = commonFn.appUA();
		const ua = app.find((item) => window.mmc.client.is(item));
		platform = appPlatform[ua] || 16;
	} catch (e) {
		console.error(JSON.stringify(e));
	}
} else {
	platform = 16;
}
platform = commonFn.getParams()['platform'] || localStorage.getItem('platform') || platform;
console.log(platform, 'platform');
if (platform) {
	localStorage.setItem('platform', platform);
}

export default platform;



// WEBPACK FOOTER //
// ./src/common/js/platform.js